import PropTypes from 'prop-types';
export var quizAnalysisMetadata = PropTypes.shape({
  quiz_title: PropTypes.string,
  decile_distribution: PropTypes.shape({
    high_extreme_values_count: PropTypes.number,
    low_extreme_values_count: PropTypes.number
  })
});
export var quizAnalysisPropType = PropTypes.shape({
  created_timestamp: PropTypes.string.isRequired,
  metadata: quizAnalysisMetadata.isRequired,
  scores: PropTypes.shape({
    decile_distribution: PropTypes.arrayOf(PropTypes.number),
    cronbachs_alpha: PropTypes.number,
    stddev: PropTypes.number,
    median_percentage: PropTypes.number,
    max_percentage: PropTypes.number,
    min_percentage: PropTypes.number,
    mean_percentage: PropTypes.number
  }).isRequired,
  attempts: PropTypes.shape({
    mean_elapsed_sec: PropTypes.number,
    students_completed: PropTypes.number,
    students_not_finished: PropTypes.number,
    students_without_attempt: PropTypes.number,
    average_attempts: PropTypes.number
  }).isRequired
});
export var studentAnalysesPropType = PropTypes.shape({
  created_timestamp: PropTypes.string.isRequired
});
export var aggregateDetailPropType = PropTypes.shape({
  count: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired
});
export var aggregatePropType = PropTypes.shape({
  correct: aggregateDetailPropType.isRequired,
  incorrect: aggregateDetailPropType.isRequired
});
export var onlyAggregatePropType = PropTypes.shape({
  no_answer: aggregateDetailPropType,
  graded: aggregateDetailPropType,
  aggregate: aggregatePropType
});
export var choiceTypeObject = PropTypes.shape({
  body: PropTypes.string,
  correct: PropTypes.bool,
  count: PropTypes.number,
  percentage: PropTypes.number
});
export var choiceTypeAnswerSummaryPropType = PropTypes.shape({
  choices: PropTypes.arrayOf(choiceTypeObject),
  no_answer: aggregateDetailPropType,
  aggregate: aggregatePropType
});
export var scoreDistributionTypeAnswerSummaryPropType = PropTypes.shape({
  no_answer: aggregateDetailPropType.isRequired,
  aggregate: aggregatePropType.isRequired,
  graded: aggregateDetailPropType.isRequired,
  score_distribution: PropTypes.arrayOf(scoreDistributionType).isRequired
});
export var scoreDistributionType = PropTypes.shape({
  count: PropTypes.number.isRequired,
  score: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired
});
export var matchingTypeAnswerSummaryPropType = PropTypes.shape({
  questions: PropTypes.objectOf(PropTypes.shape({
    body: PropTypes.string,
    answers: PropTypes.objectOf(PropTypes.shape({
      count: PropTypes.number,
      correct: PropTypes.bool,
      body: PropTypes.string,
      distractor: PropTypes.bool
    }))
  })),
  no_answer: aggregateDetailPropType,
  aggregate: aggregatePropType
});
export var richFillBlankTypeAnswerSummaryPropType = PropTypes.shape({
  blanks: PropTypes.arrayOf(PropTypes.shape({
    choices: PropTypes.arrayOf(choiceTypeObject),
    blank_text: PropTypes.string,
    blank_type: PropTypes.string,
    no_answer: PropTypes.number,
    aggregate: PropTypes.shape({
      correct: PropTypes.number,
      incorrect: PropTypes.number
    })
  })),
  no_answer: aggregateDetailPropType,
  aggregate: aggregatePropType
});
var withinARangeTypeObject = PropTypes.shape({
  end: PropTypes.string.isRequired,
  start: PropTypes.string.isRequired,
  choices: PropTypes.arrayOf(choiceTypeObject).isRequired,
  type: PropTypes.string.isRequired
});
var marginOfErrorTypeObject = PropTypes.shape({
  margin: PropTypes.string.isRequired,
  margin_type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  choices: PropTypes.arrayOf(choiceTypeObject).isRequired
});
var exactResponseTypeObject = PropTypes.shape({
  value: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  choices: PropTypes.arrayOf(choiceTypeObject).isRequired
});
var preciseResponseTypeObject = PropTypes.shape({
  value: PropTypes.string.isRequired,
  precision: PropTypes.string.isRequired,
  precision_type: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  choices: PropTypes.arrayOf(choiceTypeObject).isRequired
});
var uncategorizedTypeObject = PropTypes.shape({
  type: PropTypes.string.isRequired,
  choices: PropTypes.arrayOf(choiceTypeObject).isRequired
});
var numericRequirementTypeObject = PropTypes.oneOfType([withinARangeTypeObject, marginOfErrorTypeObject, exactResponseTypeObject, preciseResponseTypeObject, uncategorizedTypeObject]);
export var numericTypeAnswerSummaryPropType = PropTypes.shape({
  requirement: PropTypes.shape({
    correct_answers: PropTypes.arrayOf(numericRequirementTypeObject).isRequired,
    incorrect_answer_choices: PropTypes.arrayOf(choiceTypeObject).isRequired
  })
});
export var answerSummaryPropType = PropTypes.oneOfType([choiceTypeAnswerSummaryPropType, onlyAggregatePropType, matchingTypeAnswerSummaryPropType, richFillBlankTypeAnswerSummaryPropType, scoreDistributionTypeAnswerSummaryPropType]);
export var itemAnalysisPropType = PropTypes.shape({
  attempts: PropTypes.shape({
    students_responded: PropTypes.number,
    students_without_response: PropTypes.number
  }),
  metadata: PropTypes.shape({
    interaction_type: PropTypes.string,
    item_body: PropTypes.string,
    item_id: PropTypes.number,
    item_title: PropTypes.string
  }),
  scores: PropTypes.shape({
    difficulty_index: PropTypes.number,
    discrimination_index: PropTypes.number,
    mean: PropTypes.number,
    median: PropTypes.number,
    pearson_correlation: PropTypes.number,
    points_possible: PropTypes.number,
    quartile_distribution: PropTypes.arrayOf(PropTypes.number)
  }),
  answer_summary: answerSummaryPropType
});
export var afsFlags = PropTypes.shape({
  formulaEnabled: PropTypes.bool.isRequired,
  matchingEnabled: PropTypes.bool.isRequired,
  hotSpotEnabled: PropTypes.bool.isRequired,
  orderingEnabled: PropTypes.bool.isRequired,
  categorizationEnabled: PropTypes.bool.isRequired,
  trueFalseEnabled: PropTypes.bool.isRequired,
  choiceEnabled: PropTypes.bool.isRequired,
  multiAnswerEnabled: PropTypes.bool.isRequired,
  fillInTheBlankEnabled: PropTypes.bool.isRequired,
  numericEnabled: PropTypes.bool.isRequired,
  essayEnabled: PropTypes.bool.isRequired,
  fileUploadEnabled: PropTypes.bool.isRequired
});
export var eventDataPropType = PropTypes.shape({
  ipAddress: PropTypes.string,
  browserSessionID: PropTypes.string,
  eventDate: PropTypes.string,
  browserString: PropTypes.string,
  userPlatform: PropTypes.string,
  multipleSessionAttempt: PropTypes.bool
});